import { createFileRoute, notFound } from '@tanstack/react-router';
import { APPROVED_FIXTURE } from '@/features/travel-credit-card/api/home-screen';
import {
	ForceLightScheme,
	forceLightSchemeScript,
} from '@/features/travel-credit-card/layout/force-light-scheme';
import { ManageCardPage } from '@/features/travel-credit-card/manage-card/manage-card-page';

// DEV-ONLY standalone URL for the APPROVED-user Manage Card view, rendered from
// a HARDCODED fixture (APPROVED_FIXTURE) so the page can be previewed without a
// real APPROVED CVP. Resize across ~768px to preview mweb vs web adapters.
//
// GATED OUT OF PRODUCTION: beforeLoad throws notFound() in a prod build, so the
// fabricated fixture view is unreachable for real users (it would otherwise sit
// on the prod router serving a fake "Card Approved!" page to anyone with the
// URL). The REAL approved flow is served by TravelCreditCardLayout on
// /travel-credit-card from the live per-user CVP — this route is only a
// dev/design harness.
export const Route = createFileRoute('/travel-credit-card_/manage')({
	beforeLoad: () => {
		if (!import.meta.env.DEV) throw notFound();
	},
	// Pin color-scheme: light for this route (see force-light-scheme.tsx).
	head: () => ({
		scripts: [{ children: forceLightSchemeScript }],
	}),
	component: ManageCardRoute,
	ssr: true,
});

function ManageCardRoute() {
	return (
		<>
			<ForceLightScheme />
			<ManageCardPage data={APPROVED_FIXTURE} />
		</>
	);
}
